module.exports = __webpack_public_path__ + "img/e6.143ed68c.jpg";